import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function bannerLogo() {
    const banner = document.querySelector('.banner--logo');

    if (!banner) {
        return;
    }

    const bgShape = gsap.timeline();

    /* bgShape.set('.bg-shape', {
        y: 100
    }); */
    bgShape.to('.bg-shape', {
        scale: 1,
        //y: 0,
        opacity: 1,
        ease: 'elastic.out(0.5,0.5)',
        duration: 2,
        stagger: 0.3
    });
    bgShape.to('.bg-shape', {
        x: () => gsap.utils.random(-20, 20),
        y: () => gsap.utils.random(-20, 20),
        duration: () => gsap.utils.random(2, 3),
        ease: 'sine.inOut',
        repeat: -1,
        yoyo: true,
        stagger: {
            amount: 0.5,
            from: 'random'
        }
    });

    gsap.set('.bg-shape', {
        opacity: 1
    });
    gsap.utils.toArray('.bg-shape__wrapper').forEach((shape) => {
        gsap.to(shape, {
            y: -gsap.utils.random(50, 300),
            opacity: 0,
            scrollTrigger: {
                trigger: '.banner--logo',
                start: 'clamp(top 130px)',
                end: 'bottom top',
                scrub: 2
            }
        });
    });
}
